import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
/* tslint:disable:restrict-import-path */
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBody(itemIdsToUpdate, isRead) {
    var userConfiguration = getUserConfiguration();
    var shouldSuppressReadReceipts = userConfiguration.UserOptions.ReadReceipt != 'AlwaysSend';
    var update = createSetItemField('IsRead', isRead);
    var itemChanges = [];
    itemIdsToUpdate.forEach(function (id) {
        return itemChanges.push(itemChange({
            Updates: [update],
            ItemId: itemId({ Id: id }),
        }));
    });
    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
        SuppressReadReceipts: shouldSuppressReadReceipts,
    });
}
/**
 * Marks an item as read/unread
 * @param itemIdsToUpdate Item ids to be updated
 * @param isRead read/unread boolean state
 * @param requestOptions request options to be passed in
 */
export default function markItemsAsReadService(itemIdsToUpdate, isRead, requestOptions) {
    var requestBody = createRequestBody(itemIdsToUpdate, isRead);
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }, requestOptions).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=markItemsAsReadService.js.map